import { Button, Flex, Input, Text } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { IconTransactionEuro, IconZoomReset } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { repositoryMaster, repositoryPos } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../_base/model/_base/SelectListItemBase";
import { _localization } from "../../config/location";
import { MessageResponse } from "../../model/MessageResponse";
import { getUserAll } from "../../service/getSelectApi";
import "../../Styles/tab.component.css";

const MenuGroupEmployAdd = ({ idGroup }: { idGroup: string }) => {
  let idsEmp: Array<string> = [];
  //#region  table

  //data and fetching state
  const [data, setData] = useState<SelectListItemBase[]>([]);
  const [dataTemp, setDataTemp] = useState<SelectListItemBase[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  //table state

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [dateSelect, setDataSelect] = useState<string[]>([]);
  const [roleList, setRoleList] = useState<string[]>([]);
  const [dateSelectValue, setDataSelectValue] = useState<string>();
  const [dataDepartmentAndBranch, setDataDepartmentAndBranch] = useState<any[]>(
    [],
  );
  console.log(dataDepartmentAndBranch);
  const [keySearch, setKeySearch] = useState<string>("");

  // danh sách value của các tài khoản còn tồn tại trong hệ thống
  // (dataTemp là danh sách đầy đủ, chưa lọc theo từ khóa tìm kiếm)
  const existedUserValues = React.useMemo(
    () =>
      new Set(dataTemp.filter((i) => i.value).map((i) => i.value.toString())),
    [dataTemp],
  );
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const res: MRT_RowSelectionState = {};
    for (let index = 0; index < roleList.length; index++) {
      const element = roleList[index];
      res[element] = true;
    }
    setRowSelection(res);
  }, [roleList]);

  useEffect(() => {
    handleSearch(keySearch);
  }, [dateSelectValue]);

  const handleSearch = useDebouncedCallback(async (query: string) => {
    let searchResult: SelectListItemBase[] = dataTemp;

    if (query.length > 0) {
      const k = query.toLowerCase();

      const isSearch = (product: SelectListItemBase): boolean => {
        return (
          (product.text?.toLowerCase().includes(k) ||
            product.att1?.toLowerCase().includes(k) ||
            product.att2.toString()?.toLowerCase().includes(k)) ??
          false
        );
      };
      searchResult = dataTemp.filter(isSearch);
    }
    setData(searchResult);
    setKeySearch(query);
  }, 500);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const q = event.currentTarget.value;
    handleSearch(q);
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    try {
      let urlCreate = `/api/v1/menugroup/get-emp?id=` + idGroup;
      idsEmp =
        (await repositoryMaster.get<MessageResponse<string[]>>(urlCreate))
          ?.data ?? [];
      const json = await getUserAll();
      if (json) {
        const _d = json.sort((a, b) => {
          const indexA = idsEmp.indexOf(a.value);
          const indexB = idsEmp.indexOf(b.value);
          if (indexA === -1 && indexB === -1) {
            return 0;
          } else if (indexA === -1) {
            return 1;
          } else if (indexB === -1) {
            return -1;
          } else {
            return indexA - indexB;
          }
        });
        setData(_d);
        setDataTemp(_d);
        getDataDepartmentAndBranch(
          _d.filter((i) => i.att3).map((i) => String(i.att3)),
        );

        // chỉ tick lại những tài khoản còn tồn tại trong danh sách nhân viên,
        // các tài khoản đã bị xóa sẽ được bỏ qua
        const _existed = new Set(
          _d.filter((i) => i.value).map((i) => i.value.toString()),
        );
        if (idsEmp)
          setRoleList(
            idsEmp
              .filter((x) => x && _existed.has(x.toString()))
              .map((x) => x.toString()),
          );
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const authRole = async () => {
    if (!idGroup || idGroup.length < 1) {
      NotificationExtension.Fails("Nhóm quyền rỗng !");
      return;
    }

    let arryKey: string[] = [];
    // let userDeleteIds: string[] = [];
    for (const [element, selected] of Object.entries(rowSelection)) {
      // bỏ qua tài khoản không còn tồn tại trong hệ thống
      if (
        selected &&
        element &&
        element.length > 0 &&
        existedUserValues.has(element)
      )
        arryKey.push(element);
    }
    const url = "/api/v1/menugroup/auth-menu?";
    const res = await repositoryMaster.post<MessageResponse<boolean>>(url, {
      id: idGroup,
      keys: arryKey,
    });
    if (res && res.httpStatusCode === 200)
      if (res.success) {
        //  await onLoad();
        NotificationExtension.Success("Phân quyền thành công !");
      } else NotificationExtension.Fails("Phân quyền thất bại !");
    return;
  };

  const getDataDepartmentAndBranch = async (employeeIds: string[]) => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-employee-info-by-ids",
      {
        employeeIds: employeeIds,
      },
    );

    if (res && res.success) {
      const result = res.data;
      setDataDepartmentAndBranch(result);
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<SelectListItemBase>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },

      {
        accessorKey: "text",
        header: "Tên tài khoản",
      },
      {
        accessorKey: "att2",
        header: "Họ và tên",
      },
      {
        accessorKey: "department",
        header: "Phòng ban",
        Cell: ({ row }) =>
          row.original.att3 ? (
            <Text fw={500} size="12.5px">
              {
                dataDepartmentAndBranch.find(
                  (i) => String(i.employeeId) === String(row.original.att3),
                )?.departmentName
              }
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "branch",
        header: "Chi nhánh",
        Cell: ({ row }) =>
          row.original.att3 ? (
            <Text fw={500} size="12.5px">
              {
                dataDepartmentAndBranch.find(
                  (i) => String(i.employeeId) === String(row.original.att3),
                )?.branchName
              }
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "att1",
        header: "Điện thoại",
      },
    ],
    [dataDepartmentAndBranch],
  );
  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enablePagination: false,
    enableRowVirtualization: true,
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input placeholder="Nhập từ khóa ..." onChange={handleChange} />
        </Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={{ sm: "flex-start", lg: "flex-end" }}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconTransactionEuro size={14} />}
            color=""
            variant="outline"
            onClick={async () => {
              await authRole();
            }}
          >
            Phân quyền
          </Button>
          <Button
            leftSection={<IconZoomReset size={14} />}
            color="violet"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Load data
          </Button>
        </Flex>
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.value?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: {
        pageIndex: 0,
        pageSize: 1000,
      },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "60vh", minHeight: "50vh" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount: data.length,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "bold",
        fontSize: "11px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["1000"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    rowVirtualizerOptions: {
      overscan: 5,
    },
  });
  return (
    <>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default MenuGroupEmployAdd;
